<template>
  <b-container class="wrap-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="col"
      >
        <Title
          main="PROGRAM ARCHIVE"
          des="ADMAN 2019"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="col"
      >
        <div class="box-select">
          <select
            v-model="selectValueYear"
          >
            <option
              v-for="(select, i) in selects"
              :key="i"
              :value="select.value"
              >
              {{ select.title }}
            </option>
          </select>
        </div>
      </b-col>
    </b-row>
    <b-row class="wrap-content">
      <b-col
        v-for="category in categorys"
        :key="category.id"
        @click.prevent="clickToDetail(selectValueYear, category.name.toLowerCase())"
        cols="12"
        md="3"
        class="col"
      >
        <Card
          :data="category"
          class="card"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

const Title = () => import('@/components/About/Parts/Title')
const Card = () => import('@/components/Archive/Parts/Card')

export default {
  components: {
    Title,
    Card
  },

  data () {
    return {
      selects: [
        {
          title: 'ARCHIVE 2019',
          value: 2019
        }
        // {
        //   title: 'ARCHIVE 2018',
        //   value: 2018
        // },
        // {
        //   title: 'ARCHIVE 2017',
        //   value: 2017
        // },
        // {
        //   title: 'ARCHIVE 2016',
        //   value: 2016
        // },
        // {
        //   title: 'ARCHIVE 2015',
        //   value: 2015
        // },
        // {
        //   title: 'ARCHIVE 2004-2014',
        //   value: 2004
        // }
      ],
      selectValueYear: 2019
    }
  },

  computed: {
    ...mapState({
      categorys: state => state.program.categories
    })
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  },

  methods: {
    clickToDetail (year, categoryName) {
      this.$router.push({
        name: 'programArchiveCategory',
        params: {
          year,
          categoryName
        }
      })
    }
  },

  created () {
    this.$store.dispatch('program/getCategory')
  },

  watch: {
    selectValueYear (select) {
      if (select < 2019) {
        window.open('https://admanawards.com/oldsite/archive-2018')

        this.selectValueYear = 2019
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-archive {
  .box-head {
    margin-top: 22px;

    .col {
      .box-select {
        select {
          width: 100%;
          padding: 6px 50px 6px 12px;
          border-radius: 0;
          border: 1px solid #888;
          background-color: white;
          background-image: url('~@/assets/icons/icon-caret-down.png');
          background-repeat: no-repeat;
          background-position: right .7em top 50%, 0 0;
          background-size: 30px auto, 100%;
          font-size: 1.25rem;
        }
      }
    }
  }

  .wrap-content {
    margin-top: -7px;

    .col {
      .card:hover {
        background-color: $active;
      }
    }
  }
}
</style>
